export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/81699d0eeeb4d205b21bc2b7fac8f8b6cb5a6614833fe0aea4bba42b1e80b8b0.jpeg",
  corridorAerial:
    "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/33975ced49988395e8c78bf7bb581ae4f3d52c36a430299dca6bda555a649808.jpeg",
  advisory:
    "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/3636901f2f5002079ae951c992b7e27e51e64c3d0196ee9dceae766e43528697.jpeg",
  wave_city:
    "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/8d6dc8181765914f9bc401fff13442ff80dec84e2a822b4255480a8a1a2c4e26.jpeg",
  aditya_world_city:
    "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/16ef04a711d31c4f83e93aef8594a52911793736112f0c0140d93fa7fbc88d91.jpeg",
  siddharth_vihar:
    "https://static.prod-images.emergentagent.com/jobs/2c5428e0-fece-400d-aa4a-786cc44a4193/images/2205f468404b401116e0e8b67933462a997dda21f3cbc73efb7c3f91a698d874.jpeg",
};
